"use client";
import { useEffect } from "react";

// Swagger UI(self-host, public/swagger) 로더 — /api/v1/openapi.json 스펙으로 인터랙티브 테스터 렌더.
//   apiKey 를 받으면 자동 Authorize + 모든 요청에 X-API-Key 주입(로그인 사용자 전용 임시키).
export default function SwaggerClient({ apiKey }: { apiKey?: string | null }) {
  useEffect(() => {
    let cancelled = false;

    if (!document.getElementById("swagger-ui-css")) {
      const link = document.createElement("link");
      link.id = "swagger-ui-css";
      link.rel = "stylesheet";
      link.href = "/swagger/swagger-ui.css";
      document.head.appendChild(link);
    }

    const loadScript = (src: string, id: string) =>
      new Promise<void>((resolve, reject) => {
        const existing = document.getElementById(id) as HTMLScriptElement | null;
        if (existing) { resolve(); return; }
        const s = document.createElement("script");
        s.id = id; s.src = src; s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error("스크립트 로드 실패: " + src));
        document.body.appendChild(s);
      });

    (async () => {
      try {
        await loadScript("/swagger/swagger-ui-bundle.js", "swagger-ui-bundle-js");
        if (cancelled) return;
        const bundle = (window as unknown as { SwaggerUIBundle?: any }).SwaggerUIBundle;
        if (!bundle) return;
        const ui = bundle({
          url: "/api/v1/openapi.json",
          dom_id: "#swagger-ui",
          deepLinking: true,
          persistAuthorization: true,
          tryItOutEnabled: true,
          defaultModelsExpandDepth: 0,
          presets: [bundle.presets.apis],
          layout: "BaseLayout",
          // 로그인 사용자: 임시키 자동 Authorize + 모든 요청에 헤더 주입(수동 Authorize 불필요)
          onComplete: () => { if (apiKey) { try { ui.preauthorizeApiKey("ApiKeyAuth", apiKey); } catch { /* noop */ } } },
          requestInterceptor: (reqObj: any) => {
            if (apiKey) { reqObj.headers = reqObj.headers || {}; if (!reqObj.headers["X-API-Key"]) reqObj.headers["X-API-Key"] = apiKey; }
            return reqObj;
          },
        });
      } catch (e) {
        console.error(e);
        const el = document.getElementById("swagger-ui");
        if (el) el.innerHTML = '<p style="padding:24px;color:#888">테스터를 불러오지 못했습니다. 새로고침 해주세요.</p>';
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return <div id="swagger-ui" />;
}
